import { Box, SxProps } from "@outschool/backpack";
import React, { ReactNode } from "react";

const Backdrop = ({
  show,
  onClick,
  children,
  boxSx,
}: {
  show: Boolean;
  onClick?: () => void;
  children?: ReactNode;
  boxSx?: SxProps;
}) =>
  show ? (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "fixed",
          zIndex: 100,
          left: 0,
          top: 0,
          backgroundColor: "rgba(255, 255, 255, 0.75)",
        }}
        onClick={onClick}
        role="presentation"
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 300,
          ...(boxSx ? boxSx : {}),
        }}
      >
        {children}
      </Box>
    </>
  ) : (
    <>{children}</>
  );

export default Backdrop;
